import script from "./BetTypeEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./BetTypeEntry.vue?vue&type=script&setup=true&lang=js"

import "./BetTypeEntry.vue?vue&type=style&index=0&id=0eee253a&lang=css"

const __exports__ = script;

export default __exports__